/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ScholarshipfileapprovalTypeFilesScholarshiptypefileidStatus200,
  GetApiV1ScholarshipfileapprovalTypeFilesScholarshiptypefileidStatus400,
  GetApiV1ScholarshipfileapprovalTypeFilesScholarshiptypefileidStatus401,
  GetApiV1ScholarshipfileapprovalTypeFilesScholarshiptypefileidStatus404,
  GetApiV1ScholarshipfileapprovalTypeFilesScholarshiptypefileidStatus500,
  GetApiV1ScholarshipfileapprovalTypeFilesScholarshiptypefileidStatusPathParams,
  GetApiV1ScholarshipfileapprovalTypeFilesScholarshiptypefileidStatusQueryParams,
  GetApiV1ScholarshipfileapprovalTypeFilesScholarshiptypefileidStatusQueryResponse,
} from "../../types/scholarshipTypeFileApprovalController/GetApiV1ScholarshipfileapprovalTypeFilesScholarshiptypefileidStatus.ts";
import { scholarshipFileApprovalTypeFileViewModelSchema } from "../scholarshipFileApprovalTypeFileViewModelSchema.ts";

export const getApiV1ScholarshipfileapprovalTypeFilesScholarshiptypefileidStatusPathParamsSchema =
  z.object({
    scholarshipTypeFileId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1ScholarshipfileapprovalTypeFilesScholarshiptypefileidStatusPathParams>;

export const getApiV1ScholarshipfileapprovalTypeFilesScholarshiptypefileidStatusQueryParamsSchema =
  z.object({
    personId: z.optional(z.coerce.number().int()),
    culture: z.string().default("pt-BR"),
  }) as unknown as ToZod<GetApiV1ScholarshipfileapprovalTypeFilesScholarshiptypefileidStatusQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ScholarshipfileapprovalTypeFilesScholarshiptypefileidStatus200Schema =
  z.lazy(
    () => scholarshipFileApprovalTypeFileViewModelSchema,
  ) as unknown as ToZod<GetApiV1ScholarshipfileapprovalTypeFilesScholarshiptypefileidStatus200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1ScholarshipfileapprovalTypeFilesScholarshiptypefileidStatus400Schema =
  z.any() as unknown as ToZod<GetApiV1ScholarshipfileapprovalTypeFilesScholarshiptypefileidStatus400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ScholarshipfileapprovalTypeFilesScholarshiptypefileidStatus401Schema =
  z.any() as unknown as ToZod<GetApiV1ScholarshipfileapprovalTypeFilesScholarshiptypefileidStatus401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ScholarshipfileapprovalTypeFilesScholarshiptypefileidStatus404Schema =
  z.any() as unknown as ToZod<GetApiV1ScholarshipfileapprovalTypeFilesScholarshiptypefileidStatus404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ScholarshipfileapprovalTypeFilesScholarshiptypefileidStatus500Schema =
  z.any() as unknown as ToZod<GetApiV1ScholarshipfileapprovalTypeFilesScholarshiptypefileidStatus500>;

export const getApiV1ScholarshipfileapprovalTypeFilesScholarshiptypefileidStatusQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1ScholarshipfileapprovalTypeFilesScholarshiptypefileidStatus200Schema,
  ) as unknown as ToZod<GetApiV1ScholarshipfileapprovalTypeFilesScholarshiptypefileidStatusQueryResponse>;
